

class ConnectivityService {
    checkConnectivity = () => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : '/merchant/connectivity_check',
                success : (res) => {
                    if (res == "OK") {
                        resolve()
                    }
                    else {
                        reject()
                    }
                }
            })
            .fail(() => {
                reject()
            })
        })
    }
}

export default new ConnectivityService();